import React, { useContext, useEffect } from "react";

import { ButtonBack, ButtonNext, Slide, Slider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { CarouselContext } from "pure-react-carousel";
// import Arrow from "/public/arrow.svg";
import useWindowSize from "./windowSizer";

const CarouselSlider = ({ setSlideCount, setCurrentSlide }) => {
  const screenWidth = useWindowSize();
  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    const updateCarouselSlide = (slideToBeVisible) => {
      const { currentSlide, totalSlides, visibleSlides } =
        carouselContext.state;
      setSlideCount(slideToBeVisible);

      if (
        currentSlide >= totalSlides - visibleSlides ||
        currentSlide >= totalSlides - slideToBeVisible
      ) {
        setCurrentSlide(totalSlides - slideToBeVisible);
      }
    };

    if (screenWidth < 832) {
      updateCarouselSlide(1);
    } else if (screenWidth < 1088) {
      updateCarouselSlide(2);
    } else {
      updateCarouselSlide(2);
    }
  }, [screenWidth, setSlideCount, setCurrentSlide, carouselContext]);

  return (
    <div>
      <Slider>
        <Slide index={0} className="slide">
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/integration.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Integration of Liquidity</h3>
                    <p>
                      Liquidity Integration is a critical factor in promoting
                      the end-to-end use and utility of the Crypto projects
                      provided by our platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={1}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/staking_module.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Staking Module</h3>
                    <p>
                      Beleaf's White Label Crypto Exchange has a Staking module
                      that provides customers with a huge number of returns on
                      Crypto holdings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={2}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/aml.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Automated AML/KYC</h3>
                    <p>
                      KYC and AML are required steps for the creation of any
                      Crypto product. Our product is recognised to boost these
                      characteristics.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </Slide>
        <Slide index={3}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/design.webp")}
                    alt=""
                  />

                  <div>
                    <h3>UI/UX Design</h3>
                    <p>
                      The scalability of any cryptocurrency platform is
                      characterized by its capacity to adapt to the preferences
                      of the user, which is facilitated by our user-friendly UI.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={4}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/multi_coin.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Multi-Coin Support</h3>
                    <p>
                      Beleaf's White Label Crypto Exchange supports Cryptos from
                      many networks in order to attract traders.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={5}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/Token-logo.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Token Generator</h3>
                    <p>
                      There are several Cryptos accessible in the current
                      Cryptosphere, and although integrating them separately
                      would be difficult, Beleaf's Listing tool makes it simple.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={6}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/wallet-integration.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Wallet Integration</h3>
                    <p>
                      The integrated wallet offering simplifies the modalities
                      of transactions for participants that utilize the Platform
                      efficiently.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={7}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/payment-getway.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Payment Gateway</h3>
                    <p>
                      Our White Label Crypto Exchanges may easily incorporate
                      any number of Payment Gateways, eliminating the need to
                      sort an exchange.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <Slide index={8}>
          <div className="content">
            <div className="row">
              <div className="col-lg-12 mt-5">
                <div className="benefit_card1">
                  <img
                    src={require("../../image/new_white_lable/increased.webp")}
                    alt=""
                  />

                  <div>
                    <h3>Increased Scalability</h3>
                    <p>
                      Beleaf's white label crypto exchange software is designed
                      for scalability, making it easy to add new features and
                      modules.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
      </Slider>
      <div className="controls">
        <ButtonBack className="btn-arrow reverse-arrow next_arrow_btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </ButtonBack>
        <ButtonNext className="btn-arrow prv_arrow_btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </ButtonNext>
      </div>
    </div>
  );
};

export default CarouselSlider;
